import { useGraphPropContext } from "../GraphPropsContext"

import { Circle, Line, Text } from "react-konva"
import _ from "lodash"
import React from "react"

const makeLabelUpPos = (values: number[]) => {
  const [v1, v2, v3, v4] = values
  return [v1 > v2, (v1 + v3) / 2 < v2, (v2 + v4) / 2 < v3, v3 < v4]
}

interface FMatTsiGraphNodeProps {
  value: number[]
}
export const FMatTsiGraphNode: React.FC<FMatTsiGraphNodeProps> = ({ value }) => {
  const { l } = useGraphPropContext()
  if (value.length < 4) {
    console.error("Wrong value:", value)
    return null
  }

  const l0_2 = Math.ceil(l * 0.2)
  const dotR = Math.ceil(l * 0.0125)
  const dots = [value[0], value[1], value[2], value[3]].map((v, i) => [
    Math.ceil(l0_2 * (i + 1)),
    l - Math.ceil((l / 50) * v),
  ])
  const fontSize = Math.ceil(l * 0.05)
  const labelUpPos = makeLabelUpPos(value)

  return (
    <>
      {dots.map((d, i) => (
        <React.Fragment key={i}>
          <Circle radius={dotR} x={d[0]} y={d[1]} fill="#000" />
          <Text
            text={"" + value[i]}
            x={d[0]}
            y={d[1] + (labelUpPos[i] ? -fontSize : fontSize)}
            offsetX={fontSize}
            offsetY={fontSize * 0.5}
            fill="#000"
            fontSize={fontSize}
            fontStyle="bold"
            width={fontSize * 2}
            height={fontSize}
            align="center"
            verticalAlign="middle"
          />
        </React.Fragment>
      ))}
      <Line
        points={_(dots)
          .map((v) => [v[0], v[1]])
          .flatten()
          .value()}
        stroke="#000"
        strokeWidth={1}
      />
    </>
  )
}
